import {Tab} from 'pepsico-ds'
export default Tab